import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteryStatusPill: FunctionComponent<Props> = ({
    className = '',
    label,
    status,
    testId = TEST_ID
}) => {
    const statusClass = styles[`status${status}`] ?? '';

    return (
        <Wrapper
            className={`${styles.batteryStatusPill} ${statusClass} ${className}`}
            testId={testId}>
            <Wrapper className={styles.dot} />

            {label}
        </Wrapper>
    );
};

export default BatteryStatusPill;
